/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import TIMES from 'cio/utils/times';
import { CAMPAIGN_TIME_ZONES } from 'cio/utils/time-zones';
import pluralize from 'cio/utils/pluralize';

interface CampaignsReviewDateTriggeredSummaryArgs {
  campaign: CampaignModel;
}

export default class CampaignsReviewDateTriggeredSummary extends Component<CampaignsReviewDateTriggeredSummaryArgs> {
  get startTime() {
    let { campaign } = this.args;

    let time = TIMES.findBy('value', campaign.dateTriggeredStartTime);
    return time ? time.label : campaign.dateTriggeredStartTime;
  }

  get timezone() {
    let { campaign } = this.args;

    let zone = CAMPAIGN_TIME_ZONES.findBy('value', campaign.dateTriggeredZone);
    return zone ? zone.name : campaign.dateTriggeredZone;
  }

  get leadDaysLabel() {
    let { dateTriggeredLeadDays: leadDays } = this.args.campaign;

    if (leadDays > 0) {
      return `${leadDays} ${pluralize(leadDays, 'day')} after`;
    } else if (leadDays < 0) {
      let absLeadDays = Math.abs(leadDays);
      return `${absLeadDays} ${pluralize(absLeadDays, 'day')} before`;
    } else {
      return 'On';
    }
  }
}
